import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import LoadingScreen from './LoadingScreen';

export default function ProtectedRoute({ children }: { children: React.ReactNode }) {
  const { isAuthenticated, isLoading, checkAuthStatus } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    const validateAuth = async () => {
      if (!isLoading) {
        const isValid = await checkAuthStatus();
        if (!isValid) {
          navigate('/login');
        }
      }
    };

    validateAuth();
  }, [isLoading, checkAuthStatus, navigate]);

  if (isLoading) {
    return <LoadingScreen message="Checking authentication..." />;
  }

  if (!isAuthenticated) {
    navigate('/login');
    return null;
  }

  return <>{children}</>;
} 